<template>
  <div class="navigate">
    <el-row :gutter="10">
      <el-col :xs="16" :sm="20" :md="20" :lg="24" :xl="24" style="width: 100%">
        <el-menu :default-active="activeIndex" mode="horizontal" class="navigate_row" router>
          <el-menu-item :index="null">
            <img :src="logo" alt="logo" />
          </el-menu-item>
          <!-- <el-menu-item :index="null" class="hidden-md-and-down">
            <el-input placeholder="Search" v-model="searchValue">
              <el-button
                slot="append"
                icon="el-icon-search"
                class="search_btn"
                @click="onSearch(searchValue)"
              ></el-button>
            </el-input>
          </el-menu-item> -->
          <el-menu-item index="/join">Join Us</el-menu-item>
          <el-menu-item index="/media">Media</el-menu-item>
          <el-submenu index="/about" class="down">
            <template slot="title">
              <el-menu-item index="/about">About AiLife</el-menu-item>
            </template>
            <el-menu-item index="/about/people">Our People</el-menu-item>
            <el-menu-item index="/about/mission">Our Mission</el-menu-item>
            <!-- <el-menu-item index="/about/licenses">Our Licenses</el-menu-item> -->
            <el-menu-item index="/about/licenses">Our Licenses</el-menu-item>
            <el-menu-item index="/about/publications">Our Publications</el-menu-item>
            <el-menu-item index="/about/cantact">Contact Us</el-menu-item>
            <el-menu-item index="/about/privacy">Privacy Policy</el-menu-item>
          </el-submenu>
          <!-- <el-menu-item index="/tools">Tools</el-menu-item> -->

          <el-submenu index="/tools" class="down">
            <template slot="title">
              <el-menu-item index="/tools">Tools</el-menu-item>
            </template>
            <el-menu-item index="https://report.ailifeus.com">
              <a href="https://report.ailifeus.com" target="_blank" style="display: block;color: #333" class="sup_class">AilisReport<sup style="vertical-align: super">®</sup></a>
            </el-menu-item>
            <el-menu-item index="/tools/AutoHPO">AutoHPO</el-menu-item>
            <el-menu-item index="/tools/DiseaseRK">DiseaseRK</el-menu-item>
          </el-submenu>

          <el-submenu index="/products" class="down">
            <template slot="title">
              <el-menu-item index="/products">Products & Services</el-menu-item>
            </template>
            <el-menu-item index="/products/order">How to Order</el-menu-item>
            <el-menu-item index="/products/Brochures">Product Brochures</el-menu-item>
            <el-menu-item index="/products/ngs" class="sup_class">AilisNGS<sup style="vertical-align: super">®</sup></el-menu-item>
            <el-menu-item index="/products/wes">Exome Sequencing (WES)</el-menu-item>
            <el-menu-item index="/products/gene">Gene Panels</el-menu-item>
            <el-menu-item index="/products/lowWgs">Low-Pass WGS</el-menu-item>
            <!-- <el-menu-item index="/products/cma">Microarray (CMA)</el-menu-item> -->
            <el-menu-item index="/products/mito">Mito Genome Sequencing</el-menu-item>
            <el-menu-item index="/products/reanalysis">NGS Data Reanalysis</el-menu-item>
            <!-- <el-menu-item index="/products/sanger">Sanger Sequencing</el-menu-item> -->
            <el-menu-item index="/products/wgs">WGS</el-menu-item>
            <el-menu-item index="/products/f8">F8 Inversions</el-menu-item>
            <el-menu-item index="/products/Fragile">Fragile X Repeat Expansion</el-menu-item>
            <!-- <el-menu-item index="https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/order/Fragile+X+Repeat+Expansion+Analysis.pdf">
              <a href="https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/order/Fragile+X+Repeat+Expansion+Analysis.pdf" target="_blank" style="display: block;color: #333" class="sup_class">Fragile X Repeat Expansion</a>
            </el-menu-item> -->
          </el-submenu>
          <!-- <el-menu-item index="/covid19">COVID-19</el-menu-item> -->
          <el-menu-item index="/home">Home</el-menu-item>

        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import picture from "@/utils/img";
export default {
  name: "navigate",
  created() {
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (
          val.path == "/products/order" ||
          val.path == "/products/Brochures" ||
          val.path == "/products/gene" ||
          val.path == "/products/ngs" ||
          val.path == "/products/wes" ||
          val.path == "/products/lowWgs" ||
          val.path == "/products/cma" ||
          val.path == "/products/mito" ||
          val.path == "/products/reanalysis" ||
          val.path == "/products/sanger" ||
          val.path == "/products/wgs" ||
          val.path == "/products/f8" ||
          val.path == "/products/Fragile"
        ) {
          this.activeIndex = "/products";
        } else if (
          val.path == "/about/people" ||
          val.path == "/about/mission" ||
          val.path == "/about/licenses" ||
          val.path == "/about/publications" ||
          val.path == "/about/cantact" ||
          val.path == "/about/privacy"
        ) {
          this.activeIndex = "/about";
        } else if (
          val.path == "/media/news1" ||
          val.path == "/media/news3" ||
          val.path == "/media/news2" ||
          val.path == "/media/blog1" ||
          val.path == "/media/blog2" ||
          val.path == "/media/blog3"
        ) {
          this.activeIndex = "/media";
        } else if (
          val.path == "/tools/AutoHPO" ||
          val.path == "/tools/DiseaseRK"
        ) {
          this.activeIndex = "/tools";
        } else {
          this.activeIndex = val.path;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      logo: picture.logo(),
      activeIndex: this.$route.path,
      searchValue: "",
    };
  },
  methods: {
    handleSelect(key, keyPath) {

    },
    onSearch(val) {
      let value = val.toLowerCase();
      let covid = "covid19 There appears to be a lot of confusion regarding the types of COVID-19 testing, the suitability of different tests for different purposes, and what information they provide. This is understandable in a rapidly evolving situation and with the number of new tests currently being granted emergency authorization. To try to simplify the information out there, we will attempt to summarize currently available tests in a clear and concise manner.Overall, tests are divided into two main groups: diagnostic tests and serological tests (or antibody tests). These two groups of tests have distinct purposes".toLowerCase();
      let Home = "home".toLowerCase();
      let server = "products & services We offer end to end NGS gene panels, WES and WGS on a clinical basis. In addition, we have developed NGS analysis tools including: 1) Annotation of Genes and Proteins Systematically (A-GPS®), 2) Interpretation of Genes and Proteins Systematically (I-GPS®), 3) Discovery of Genes with Possible disease contributions Systematically (D-GPS®). These tools, coupled with our AiLife LIS and NGS Interpretation System (AilisNGS®), deep learning and AI, can greatly facilitate the analysis, interpretation, and mining of NGS data.".toLowerCase();
      let about = "about ailife Our People Our Mission Our Licenses Our Publications Contact Us  AiLife Diagnostics, an employee owned company, was founded near the Texas Medical Center in Houston, Texas with the mission to provide fast and accurate interpretation services and mining of NGS data using the expertise and proprietary tools developed in house. Our scientific and technical teams are comprised of ABMGG certified geneticists, clinicians, PhD genome scientists, bioinformatics and IT experts. We have an extensive amount of experience in analyzing and reporting tens of thousands of clinical exome cases, targeted gene panel, microarray and more. ​ We have developed NGS analysis tools including: 1) Annotation of Genes and Proteins Systematically (A-GPS®), 2) Interpretation of Genes and Proteins Systematically (I-GPS®), 3) Discovery of Genes with Possible disease contributions Systematically (D-GPS®). These tools, coupled with our AiLife LIS and NGS Interpretation System (AilisNGS®), deep learning and AI, can greatly facilitate the analysis, interpretation, and mining of NGS data. ​In addition, we are also launching the AiLIfe Platform for online forums, education and genetic counseling. Our goal is to empower the medical community by providing comprehensive genetic data analyses and interpretations through innovation, research, and education.".toLowerCase();
      let media = "ashg 2019 meeting, houston aiLife diagnostics and bgi americas partner to provide clinical wgs solution".toLowerCase();
      let join = "clinical laboratory director clinical genomic scientist position".toLowerCase();
      let gene = "gene panel".toLowerCase();
      let how = "To order a diagnostic or screening test please download and follow the instructions on the following forms. AiLife test requisition form and AiLife genetic testing consent form should be filled by patient and healthcare provider. For specimen requirements and shipping instruction please refer to the information in the final form.Individuals interested in ordering a test, should talk to their healthcare provider in order to have a test requested.For more information on test ordering please contact us at: contact@ailifeus.com or 346.342.1802.".toLowerCase();
      if (covid.includes(value)) {
        // this.$router.push({ path: "/covid19" });
      } else if (Home.includes(value)) {
        this.$router.push({ path: "/home" });
      } else if (server.includes(value)) {
        this.$router.push({ path: "/products" });
      } else if (about.includes(value)) {
        this.$router.push({ path: "/about" });
      } else if (media.includes(value)) {
        this.$router.push({ path: "/media" });
      } else if (join.includes(value)) {
        this.$router.push({ path: "/join" });
      } else if (gene.includes(value)) {
        this.$router.push({ path: "/products/gene" });
      } else if (how.includes(value)) {
        this.$router.push({ path: "/products/order" });
      }
    },
  },
};
</script>

<style lang='scss'>
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  text-align: center !important;
  color: $color_black !important;
}

.navigate {
  background: rgba(255, 255, 255, 0.9);
  height: 100%;

  .el-input-group__append button.el-button {
    background: #afd19f;

    i {
      color: $color_white;
    }
  }

  .el-row {
    padding: 5px 0 5px 0;
    box-sizing: border-box;
  }

  .el-menu.el-menu--horizontal {
    border: none;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    background: none;
  }

  .el-menu-item {
    height: 80px !important;
    line-height: 80px !important;
    font-size: 16px;
    color: $color_black !important;
    font-weight: 500;
  }

  img {
    width: 150px;
    height: 80px;
  }

  .el-menu {
    height: 100%;

    & > li:nth-child(n + 2) {
      float: right;
    }
  }

  .down {
    height: 80px;
    line-height: 78px;
    position: relative;

    .el-submenu__title {
      height: 80px !important;
      line-height: 78px;

      i {
        position: absolute;
        right: 5px;
      }

      & > li {
        height: 80px;
        line-height: 78px;
        padding: 0 10px;
        min-width: 0;
        color: $color_black;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/header/header.vue